import React from 'react';
import { Text } from '@starryui10/typography/Text';
import { color } from '@starryui10/theme/color';
import { useDirectoryState } from '../../state/DirectoryState';

export const SubCaption = () => {
    const { data } = useDirectoryState();
    return (
        <Text color={color.Grey.G60} variant="normal.regular">
            {data?.allMainDirectory.totalCount} items
        </Text>
    );
};
